import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { resolveSeo, getSiteUrl } from "@/lib/seo";
import { buildSchemas } from "@/lib/schema";

export default function JsonLd() {
  const location = useLocation();

  useEffect(() => {
    const seo = resolveSeo(location.pathname);
    const url = `${getSiteUrl()}${seo.canonicalPath}`;
    const schemas = buildSchemas(seo, url);

    document
      .querySelectorAll('script[data-readdy-seo]')
      .forEach((node) => node.remove());

    schemas.forEach((schema) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-readdy-seo", "true");
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    return () => {
      document
        .querySelectorAll('script[data-readdy-seo]')
        .forEach((node) => node.remove());
    };
  }, [location.pathname]);

  return null;
}